export const GET_RESERVATION = 'GET_RESERVATION_RESERVE';
export const GET_PASSENGERS = 'GET_PASSENGERS';
export const GET_NEW_PASSENGERS = 'GET_NEW_PASSENGERS';
export const GET_TOTAL_PASSENGERS = 'GET_TOTAL_PASSENGERS';
export const GET_AVALIABLE_EXTRAS = 'GET_AVALIABLE_EXTRAS';
export const GET_NEW_EXTRAS = 'GET_NEW_EXTRAS';
export const GET_EXTRAS_TO_ADD = 'GET_EXTRAS_TO_ADD';
export const GET_ANY_BAGS_TO_ADD = 'GET_ANY_BAGS_TO_ADD';
export const GET_LOADING = 'GET_LOADING';
export const GET_RESERVATION_CODE = 'GET_RESERVATION_CODE';
export const GET_VALID_CODE = 'GET_VALID_CODE';
export const GET_APPEND_ICON = 'GET_APPEND_ICON';
export const GET_BOARDING_PASSES = 'GET_BOARDING_PASSES';
export const GET_SELECTED_EXTRA_BY_ID = 'GET_SELECTED_EXTRA_BY_ID';
export const GET_EXTRA_BY_ID = 'GET_EXTRA_BY_ID';
export const GET_EXTRA_UNIT_PRICE = 'GET_EXTRA_UNIT_PRICE';
export const GET_EXTRA_PRICE_TIMES_QUANTITY = 'GET_EXTRA_PRICE_TIMES_QUANTITY';
export const GET_TOTAL_BONUS = 'GET_TOTAL_BONUS';

